import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const SlideshowAccessibleButton = styled.button<{
  $navShown?: boolean;
}>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  appearance: none;
  overflow: hidden;
  border: 0;
  background: transparent;
  pointer-events: none;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    height: ${(props) => (props.$navShown ? 'calc(100% - 42px)' : '100%')};
  }
`;
